module.exports = __webpack_public_path__ + "img/s2v4.9fc8d245.jpeg";